// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TzMOwQNut7wl1gevEczq{color:var(--content-primary-primary);flex-direction:column;gap:12px;padding:12px 16px 16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTestSMS": `TzMOwQNut7wl1gevEczq`,
	"wrapTestSms": `TzMOwQNut7wl1gevEczq`
};
export default ___CSS_LOADER_EXPORT___;
